import React, { useState } from "react";
import PopupModal from "../../../atoms/popup-modal";
import { object } from "prop-types";
import { format } from "date-fns";
import Download from "../../../atoms/icons/download";

import "./download-invoice.m.css";

const DownloadInvoices = ({ plan }) => {
  const invoices = plan.invoices.length ? plan.invoices.filter((i) => i.downloadable && i.amount_cents > 0) : [];
  if (!invoices.length) return null;
  const [showPopup, setShowPopup] = useState(false);
  const blankRowsToBeAdded = invoices.length < 5 ? 5 - invoices.length : 0;

  return (
    <React.Fragment>
      <span onClick={() => setShowPopup(true)} styleName="download-receipt">
        Download receipt
      </span>
      {showPopup ? (
        <PopupModal closePopup={() => setShowPopup(false)}>
          <table styleName="wrapper">
            <thead>
              <tr styleName="heading">
                <th>Date</th>
                <th>Invoice No.</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice) => {
                if (invoice.downloadable && invoice.amount_cents > 0) {
                  const invoiceDate = format(new Date(invoice.created_at), "dd/MM/yyyy");
                  return (
                    <tr key={invoice.id} styleName="item">
                      <td styleName="date">{invoiceDate}</td>
                      <td styleName="number">{invoice.sequenced_invoice_number}</td>
                      <td>
                        <a
                          styleName="link"
                          rel="noreferrer"
                          href={`/api/v1/members/me/subscriptions/${plan.id}/invoices/${invoice.id}/download`}
                          target="_blank"
                        >
                          <Download />
                        </a>
                      </td>
                    </tr>
                  );
                }
              })}
              <EmptyTableRows rowsToInsert={blankRowsToBeAdded} />
            </tbody>
          </table>
        </PopupModal>
      ) : null}
    </React.Fragment>
  );
};

DownloadInvoices.propTypes = {
  plan: object,
};

function EmptyTableRows({ rowsToInsert }) {
  if (rowsToInsert < 1) return null;
  const rows = [];
  for (let i = 0; i < rowsToInsert; i++) {
    rows.push(
      <tr>
        <td colSpan="3" styleName="empty-row"></td>
      </tr>
    );
  }
  return rows;
}

export default DownloadInvoices;
